<template>
  <standard-container :title="$t('status.players')">
    <template v-slot:title>
      <v-btn
        :title="$t('navbar.viewer')"
        icon
        @click="goToViewer"
      >
        <v-icon>mdi-account-convert-outline</v-icon>
      </v-btn>
      <v-text-field
        v-if="showSearch"
        v-model="search"
        :label="$t('project.search')"
        single-line
        hide-details
        clearable
      />
      <v-btn
        icon
        @click="showSearch = !showSearch"
      >
        <v-icon> search </v-icon>
      </v-btn>
    </template>

    <template v-slot:content>
      <v-container
        grid-list-md
        fluid
        fill-height
      >
        <v-layout column>
          <v-flex xs1>
            <log-player-incident
              :list-errored="playerErrored"
              :search="search"
              @itemSelected="itemSelected"
            />
          </v-flex>

          <v-flex
            class="my-2"
            overflow-hidden
          >
            <v-tabs
              right
              class="body-1 fill-height elevation-3 status-tree-view"
              grow
            >
              <v-tab>{{ $t("status.groups") }}</v-tab>
              <v-tab>{{ $t("status.city") }}</v-tab>
              <v-tab>{{ $t("status.department") }}</v-tab>
              <v-tab-item
                class="fill-height"
                style="overflow-y: auto"
              >
                <v-treeview
                  :items="groupsItem"
                  class="status-tree-view fill-height"
                  open-on-click
                  :search="search"
                  color="grey"
                  hoverable
                  :activatable="true"
                  return-object
                  @update:active="itemSelected"
                >
                  <template v-slot:prepend="{ item }">
                    <template v-if="item.problems !== undefined">
                      <template v-if="item.problems.length > 0">
                        <v-icon v-if="item.problems[0].name == 'group'" />
                        <v-icon v-else>
                          {{ "mdi-" + item.problems[0].icon }}
                        </v-icon>
                      </template>
                    </template>
                  </template>
                </v-treeview>
              </v-tab-item>
              <v-tab-item>
                <v-treeview
                  :items="citiesItem"
                  class="status-tree-view"
                  open-on-click
                  :search="search"
                  color="grey"
                  hoverable
                  :activatable="true"
                  return-object
                  @update:active="itemSelected"
                >
                  <template v-slot:prepend="{ item }">
                    <template v-if="item.problems !== undefined">
                      <template v-if="item.problems.length > 0">
                        <v-icon v-if="item.problems[0].name == 'group'" />
                        <v-icon v-else>
                          {{ "mdi-" + item.problems[0].icon }}
                        </v-icon>
                      </template>
                    </template>
                  </template>
                </v-treeview>
              </v-tab-item>
              <v-tab-item>
                <v-treeview
                  :items="dptsItem"
                  class="status-tree-view"
                  open-on-click
                  :search="search"
                  color="grey"
                  hoverable
                  :activatable="true"
                  return-object
                  @update:active="itemSelected"
                >
                  <template v-slot:prepend="{ item }">
                    <template v-if="item.problems !== undefined">
                      <template v-if="item.problems.length > 0">
                        <v-icon v-if="item.problems[0].name == 'group'" />
                        <v-icon v-else>
                          {{ "mdi-" + item.problems[0].icon }}
                        </v-icon>
                      </template>
                    </template>
                  </template>
                </v-treeview>
              </v-tab-item>
            </v-tabs>
          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </standard-container>
</template>

<script>
// Components
import standardContainer from "../Common/StandardContainer";
import logPlayerIncident from "./LogPlayerIncident";

// Connectors
import { PlayerConnector } from "../Database/PlayerConnector";

export default {
  components: {
    standardContainer,
    logPlayerIncident,
  },
  props: {
    playerConnected: {
      type: Array,
      required: true,
    },
    playerDisconnected: {
      type: Array,
      required: true,
    },
    playerProblems: {
      type: Array,
      required: true,
    },
    playerNoResponse: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      playerConnector: new PlayerConnector(this.$store.state.user),
      playerErrored: [],
      groupsItem: [],
      citiesItem: [],
      dptsItem: [],
      showSearch: false,
      search: "",
    };
  },
  created() {
    this.concatAllErrors()
      .then((listErrored) => {
        this.playerErrored = listErrored;
        this.formatDate();

        this.getAllGroupedPlayers();
        this.getAllCitiesPlayers();
        this.getAllDptsPlayers();
      })
      .catch((err) => {
        console.error(err);
      });
  },
  methods: {
    itemSelected(item) {
      this.$emit("itemSelected", item);
    },
    formatDate() {
      for (let i = 0; i < this.playerErrored.length; i++) {
        this.playerErrored[i].lastConnection = this.playerErrored[i].lastConnection.replace("00:00", "");
        this.playerErrored[i].lastConnection = this.playerErrored[i].lastConnection.replace("00/00/0000", "");
      }
    },
    goToViewer() {
      this.$router.push({ path: "/viewer" });
    },
    concatAllErrors() {
      return new Promise((resolve) => {
        let listErrored = [];
        listErrored = listErrored.concat(this.playerDisconnected, this.playerProblems, this.playerNoResponse);

        // REMOVE DUPLICATES AND CONCAT ERRORS
        for (let i = 0; i < listErrored.length; i++) {
          for (let j = i + 1; j < listErrored.length; j++) {
            if (listErrored[i].id == listErrored[j].id) {
              listErrored[i].problems = listErrored[i].problems.concat(listErrored[j].problems);
              listErrored.splice(j, 1);
              j--;
            }
          }
        }

        return resolve(listErrored);
      });
    },
    getAllGroupedPlayers() {
      this.playerConnector.getAllPlayersGrouped().then((groupedPlayers) => {
        this.groupsItem = this.createList(groupedPlayers, this.playerConnected, this.playerErrored);
      });
    },
    getAllCitiesPlayers() {
      this.playerConnector.getAllPlayersCities().then((cityPlayers) => {
        this.citiesItem = this.createList(cityPlayers, this.playerConnected, this.playerErrored);
      });
    },
    getAllDptsPlayers() {
      this.playerConnector.getAllPlayersDpts().then((dptsPlayers) => {
        this.dptsItem = this.createList(dptsPlayers, this.playerConnected, this.playerErrored);
      });
    },
    createList(currentList, connected, errored) {
      // Create all players
      const allPlayers = {
        id: 0,
        name: this.$t("dialog.all"),
        children: [],
      };

      for (let i = 0; i < connected.length; i++) {
        allPlayers.children.push(connected[i]);
      }
      for (let i = 0; i < errored.length; i++) {
        allPlayers.children.push(errored[i]);
      }

      // Add specifics groups/cities/dpts
      if (currentList !== undefined) {
        let id_tree = 1;
        for (let i = 0; i < currentList.length; i++) {
          currentList[i].id = id_tree;
          id_tree++;

          for (let j = 0; j < currentList[i].children.length; j++) {
            currentList[i].children[j].id = id_tree;
            id_tree++;

            for (let h = 0; h < connected.length; h++) {
              if (currentList[i].children[j].plyrID == connected[h].id) {
                currentList[i].children[j] = connected[h];
              }
            }
            for (let h = 0; h < errored.length; h++) {
              if (currentList[i].children[j].plyrID == errored[h].id) {
                currentList[i].children[j] = errored[h];
              }
            }
          }
        }
      }

      currentList.unshift(allPlayers);

      return currentList;
    },
  },
};
</script>

<style>
.status-tree-view > .v-tabs-items {
  max-height: calc(100% - 48px);
  overflow: auto;
}
</style>
